export default __webpack_public_path__ + "static/media/placeholder_store04-es-web.5d9e67f4.png";